import { updateRelationshipReferences } from 'shared/services/backend-api';
import { IDPrefixes } from 'shared/types/id';
import { Relationship } from 'shared/types/relationship';
import { Task } from 'shared/types/task';
import { createPrefixId } from 'shared/utils/prefix-id';

export const updateLinkedRelationships = (
  taskPairs: Array<{ oldTask: Task; newTask: Task }>,
  relationships: Relationship[],
) => {
  if (!taskPairs.length) {
    return;
  }

  // Create map of old task IDs to new task IDs
  const oldToNewTaskIdMap = new Map<string, string>();
  taskPairs.forEach(({ oldTask, newTask }) => {
    if (!oldTask.parentIds?.length) {
      oldToNewTaskIdMap.set(oldTask.id, newTask.id);
    }
  });

  if (!oldToNewTaskIdMap.size) {
    return;
  }

  // Group relationships by relationship ID
  const relationshipUpdates = new Map<
    string,
    { id: string; newReferences: string[] }
  >();

  oldToNewTaskIdMap.forEach((newTaskId, oldTaskId) => {
    const taskRelationshipId = createPrefixId(oldTaskId, IDPrefixes.Task);
    const newTaskRelationshipId = createPrefixId(newTaskId, IDPrefixes.Task);

    relationships.forEach((relationship) => {
      if (relationship.references.includes(taskRelationshipId)) {
        const existing = relationshipUpdates.get(relationship.id);
        if (existing) {
          if (!existing.newReferences.includes(newTaskRelationshipId)) {
            existing.newReferences.push(newTaskRelationshipId);
          }
        } else {
          relationshipUpdates.set(relationship.id, {
            id: relationship.id,
            newReferences: [...relationship.references, newTaskRelationshipId],
          });
        }
      }
    });
  });

  if (!relationshipUpdates.size) {
    return;
  }

  updateRelationshipReferences(
    Array.from(relationshipUpdates.values()).map(({ id, newReferences }) => ({
      id,
      references: newReferences,
    })),
  );
};
